export const THEMES = [
  // ── Ligeria (défaut) ──
  { id: 'ligeria', name: 'Ligeria', mode: 'maison',
    primary: '#626F53', light: '#74825F', dark: '#3F4838',
    gradient: 'linear-gradient(135deg,#626F53,#3F4838)',
    paper: { bg: '#F6F1E4', card: '#FFFFFF', text: '#22261E', muted: '#5F6657', border: '#DBD2BD' } },
  { id: 'olive',   name: 'Olive',   mode: 'maison',
    primary: '#5F6F4E', light: '#71835E', dark: '#49563B',
    gradient: 'linear-gradient(135deg,#5F6F4E,#49563B)',
    paper: { bg: '#F2F1E7', card: '#FBFAF4', text: '#20241B', muted: '#666B5B', border: '#D9DACB' } },

  // ── Mono ──
  { id: 'green',      name: 'Vert',       mode: 'mono',  primary: '#2D6A4F', light: '#40916C', dark: '#1B4332' },
  { id: 'red',        name: 'Rouge',      mode: 'mono',  primary: '#B91C1C', light: '#DC2626', dark: '#7F1D1D' },
  { id: 'blue',       name: 'Bleu',       mode: 'mono',  primary: '#1D4ED8', light: '#3B82F6', dark: '#1E3A8A' },
  { id: 'purple',     name: 'Violet',     mode: 'mono',  primary: '#7C3AED', light: '#8B5CF6', dark: '#5B21B6' },
  { id: 'orange',     name: 'Orange',     mode: 'mono',  primary: '#EA580C', light: '#F97316', dark: '#9A3412' },
  { id: 'rose',       name: 'Rose',       mode: 'mono',  primary: '#DB2777', light: '#EC4899', dark: '#9D174D' },
  { id: 'black',      name: 'Noir',       mode: 'mono',  primary: '#1F2937', light: '#374151', dark: '#111827' },
  // ── Multi ──
  { id: 'sunset',     name: 'Sunset',     mode: 'multi', primary: '#F97316', light: '#FB923C', dark: '#EA580C', gradient: 'linear-gradient(135deg,#F97316,#DB2777)' },
  { id: 'ocean',      name: 'Océan',      mode: 'multi', primary: '#0EA5E9', light: '#38BDF8', dark: '#0284C7', gradient: 'linear-gradient(135deg,#0EA5E9,#7C3AED)' },
  { id: 'aurora',     name: 'Aurora',     mode: 'multi', primary: '#059669', light: '#10B981', dark: '#047857', gradient: 'linear-gradient(135deg,#059669,#06B6D4)' },
  { id: 'gold',       name: 'Or & Brun',  mode: 'multi', primary: '#B45309', light: '#D97706', dark: '#92400E', gradient: 'linear-gradient(135deg,#B45309,#DC2626)' },
  // ── Neon ──
  { id: 'neon_green', name: 'Néon Vert',  mode: 'neon',  primary: '#00FF41', light: '#39FF14', dark: '#00CC33' },
  { id: 'neon_pink',  name: 'Néon Rose',  mode: 'neon',  primary: '#FF10F0', light: '#FF69B4', dark: '#CC00CC' },
  { id: 'neon_cyan',  name: 'Néon Cyan',  mode: 'neon',  primary: '#00FFFF', light: '#7DF9FF', dark: '#00CCCC' },
  { id: 'neon_gold',  name: 'Néon Or',    mode: 'neon',  primary: '#FFD700', light: '#FFF44F', dark: '#CCA800' },
];

export const DEFAULT_THEME = 'ligeria';

export function applyTheme(themeId) {
  const t = THEMES.find(th => th.id === themeId) || THEMES[0];
  const r = document.documentElement;
  r.style.setProperty('--green',      t.primary);
  r.style.setProperty('--green-light',t.light);
  r.style.setProperty('--green-btn',  t.primary);
  r.style.setProperty('--green-dark', t.dark);
  r.style.setProperty('--wg',         t.primary);
  r.style.setProperty('--wg2',        t.light);
  r.style.setProperty('--btn-gradient', t.gradient || `linear-gradient(135deg,${t.primary},${t.dark})`);

  if (t.mode === 'neon') {
    r.setAttribute('data-theme', 'neon');
    r.style.setProperty('--bg',      '#0d0d0d');
    r.style.setProperty('--text',    '#e5e7eb');
    r.style.setProperty('--border',  '#2a2a2a');
    r.style.setProperty('--card-bg', '#111827');
    r.style.setProperty('--muted',   '#9CA3AF');
  } else if (t.paper) {
    // Thèmes maison : fond papier chaud
    r.removeAttribute('data-theme');
    r.style.setProperty('--bg',      t.paper.bg);
    r.style.setProperty('--text',    t.paper.text);
    r.style.setProperty('--border',  t.paper.border);
    r.style.setProperty('--card-bg', t.paper.card);
    r.style.setProperty('--muted',   t.paper.muted);
  } else {
    r.removeAttribute('data-theme');
    r.style.setProperty('--bg',      '#F9FAFB');
    r.style.setProperty('--text',    '#1a1a1a');
    r.style.setProperty('--border',  '#E5E7EB');
    r.style.setProperty('--card-bg', '#ffffff');
    r.style.setProperty('--muted',   '#6B7280');
  }
}
